// JsFromRoutes CacheKey 363400a3cb4d49de14303b737922a1d9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/lp/:url_slug'),
  buyAGift: /* #__PURE__ */ definePathHelper('get', '/buy-a-gift'),
  christmasGifts: /* #__PURE__ */ definePathHelper('get', '/browse/christmas-gifts'),
  halloweenGifts: /* #__PURE__ */ definePathHelper('get', '/browse/halloween-gifts'),
  nationwide: /* #__PURE__ */ definePathHelper('get', '/nlp/:url_slug'),
}
